import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedSymbol } from '../pages/slices/streamCryptoInfoSlicer';
import styles from './StreamMostBuySell.module.css'
import { useNavigate } from 'react-router-dom';

const StreamMostBuySell = () => {
  const { symbolIcons, initialPrices, prices } = useSelector(state => state.streamCryptoInfo);  
  const { symbolLimit } = useSelector(state => state.globalData);
  const [topEntries, setTopEntries] = useState([]);
  const [bottomEntries, setBottomEntries] = useState([]);

  const dispatch = useDispatch();  
  const navigate = useNavigate();  

  const getPercentageChange = useCallback((symbol) => {
    if (initialPrices[symbol] === null || prices[symbol] === null) {
      return null;
    }
    const initialPrice = parseFloat(initialPrices[symbol]);
    const currentPrice = parseFloat(prices[symbol]);        
    const percentageChange = ((currentPrice - initialPrice) / initialPrice) * 100    
    return percentageChange.toFixed(2);
  }, [initialPrices, prices]);

  const formatSymbol = (symbol) => {
    let formattedSymbol = symbol;
    if (symbol.length > 3) {
      formattedSymbol = symbol.slice(0, 3) + '...';
    }
    return formattedSymbol;
  };

  const handleSelection = (item) => { 
    const ticker = item.slice(0, -4) + '-USD';
    dispatch(setSelectedSymbol(ticker));
    navigate('/TRViwerPage');
  };  

  useEffect(() => {
    if (prices && initialPrices) {
        const symbols = Object.keys(prices).slice(0, symbolLimit);
        const percentageChanges = symbols
            .map(symbol => ({
                symbol,
                percentageChange: getPercentageChange(symbol)
            }))
            .filter(item => item.percentageChange !== null);

        percentageChanges.sort((a, b) => b.percentageChange - a.percentageChange);

        setTopEntries(percentageChanges.slice(0, 3));
        setBottomEntries(percentageChanges.slice(-3).reverse());
    }
  }, [prices, initialPrices, getPercentageChange, symbolLimit]);

  return (
    <>
    {/* {topEntries.length > 0 && bottomEntries.length > 0 && ( */}
      <div style={{ display: 'flex', textAlign: 'left' }}>
        <fieldset className='fieldset' style={{ width: '50px', height: '96px', marginRight: '10px' }}>
          <legend style={{ color: '#6ac46b' }} className='legend'>Top 3 Buy</legend>
          <table style={{ width: '130px', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <tbody>
            {topEntries.map(entry => (              
                <tr 
                  className={styles.table_row} 
                  style={{ borderBottom: '1px solid #525252' }} 
                  onClick={() => handleSelection(entry.symbol)} 
                  key={entry.symbol}
                >
                  <td style={{ width: '20%' }}>
                    <img
                      src={symbolIcons[entry.symbol]}
                      alt=""
                      style={{ width: '20px', marginRight: '10px', borderRadius: '50%' }}
                    />
                  </td>
                  <td style={{ width: '40%' }}>{formatSymbol(entry.symbol.slice(0, -4))}</td>
                  <td style={{ width: '40%', color: getPercentageChange(entry.symbol) > 0 ? '#6ac46a' : '#ec8282' }}>
                    {getPercentageChange(entry.symbol)}%
                  </td>
                </tr>              
            ))}
            </tbody>
          </table>
        </fieldset>
    
        <fieldset className='fieldset' style={{ width: '50px', height: '96px' }}>
          <legend style={{ color: '#e17d7c' }} className='legend'>Top 3 Sell</legend>
          <table style={{ width: '130px', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <tbody>
              {bottomEntries.map(entry => (                
                <tr className={styles.table_row} style={{ borderBottom: '1px solid #525252' }} onClick={() => handleSelection(entry.symbol)} key={entry.symbol}>
                  <td style={{ width: '20%' }}>
                    <img
                      src={symbolIcons[entry.symbol]}
                      alt=""
                      style={{ width: '20px', marginRight: '10px', borderRadius: '50%' }}
                    />
                  </td>
                  <td style={{ width: '40%' }}>{formatSymbol(entry.symbol.slice(0, -4))}</td>
                  <td style={{ width: '40%', color: entry.percentageChange > 0 ? '#6ac46a' : '#ec8282' }}>{entry.percentageChange}%</td>
                </tr> 
              ))}
            </tbody>
          </table>
        </fieldset>    
      </div>
    {/* )} */}
    </>
  );
};

export default StreamMostBuySell;